import { jsx as _jsx } from "react/jsx-runtime";
import { useDroppable } from '@dnd-kit/core';
import { colors } from 'app/styles/vars.js';
function Droppable({ id, className, testid, children }) {
    const { isOver, setNodeRef } = useDroppable({
        id,
    });
    const style = {
        backgroundColor: isOver ? colors.yuzuPrimaryColorLight : 'transparent',
    };
    return (_jsx("div", { ref: setNodeRef, className: className, style: style, "data-testid": testid, children: children }));
}
export default Droppable;
